import { render, staticRenderFns } from "./text-tag-editor.vue?vue&type=template&id=bc95b862&scoped=true"
import script from "./text-tag-editor.ts?vue&type=script&lang=ts&external"
export * from "./text-tag-editor.ts?vue&type=script&lang=ts&external"
import style0 from "./text-tag-editor.less?vue&type=style&index=0&id=bc95b862&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc95b862",
  null
  
)

export default component.exports